export function isUserVisibleDocId(
  docId: string,
  workspaceId: string
): boolean {
  return (
    docId !== workspaceId &&
    !docId.startsWith('db$') &&
    !docId.startsWith('userdata$')
  );
}

export function filterUserVisibleDocIds(
  docIds: readonly string[],
  workspaceId: string
): string[] {
  return docIds.filter(docId => isUserVisibleDocId(docId, workspaceId));
}
